export enum NotificationTypes {
  ROUTE_DISPATCHED = "Route Dispatched",
  FIFTEEN_MINUTES_BEFORE_SERVICE = "15 Minutes Before Service",
  SERVICE_DELAYED = "Service Delayed",
  STATUS_UPDATES = "Status Updates",
  SERVICE_MODIFIED = "Service Modified",
}

/**
 * Array of all notification types for easy iteration
 */
export const NOTIFICATION_TYPES_ARRAY = Object.values(NotificationTypes);
